<template>
    <div class="myClient">
        <div class="headline">我们的客户</div>
        <!--客户展示-->
        <img src="../../../assets/img/home/客户.png" height="184" width="1200"/>
    </div>
</template>

<script>
    export default {
        name: "myClient",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("myClient")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    .myClient {
        width: 1200px;
        margin: 0 auto;

        .headline {
            margin-bottom: 50px;
        }
    }
</style>
